import { render } from "./profile.vue?vue&type=template&id=0dfe5319&scoped=true&ts=true&lang=pug"
import script from "./profile.vue?vue&type=script&lang=ts"
export * from "./profile.vue?vue&type=script&lang=ts"

import "./profile.vue?vue&type=style&index=0&id=0dfe5319&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dfe5319"]])

export default __exports__